export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7528.ad9728ce.jpg";